import axios from 'axios'
import env from '@/configs/env'
import { Message, Loading } from 'element-ui'
import { getToken } from '@/utils/index'

const service = axios.create({
  baseURL: env.ApiDomain,
  timeout: 5000
})

var loading

service.interceptors.request.use(
  config => {
    const token = getToken()
    config.options = Object.assign(
      {
        isLoading: true
      },
      config.options
    )
    if (token) {
      Object.assign(config, {
        headers: {
          'X-Access-Token': token
        }
      })
    }
    if (config.options.isLoading) {
      loading = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    if (loading) loading.close()
    return response
  },
  error => {
    if (loading) loading.close()
    const { status, data } = error.response
    const msg = data.error.message
    switch (status) {
      case 401:
        if (msg === '没有权限进行设置') {
          Message.error('没有操作权限！')
          return Promise.reject(error)
        }
        Message.error(msg)
        window.vm.$router.replace('/login')
        break
      // case 412:
      //   window.vm.$message.error(msg)
      //   window.vm.$router.replace('/login')
      //   break
      default:
        Message.error(Array.isArray(msg) ? msg[0] : msg)
        return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

export default service
